import { ObjectJsonSchemaBase } from "./object-json-schema.model";


export class ArrayJsonSchemaBase extends ObjectJsonSchemaBase {

    override type: string = "array"
    items: any = new ObjectJsonSchemaBase(null)
}

export interface ArrayJsonSchema extends ArrayJsonSchemaBase { }